var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "py-3" }, [
    _c(
      "form",
      {
        attrs: { "data-id": _vm.name },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("validated-input", {
              staticClass: "mr-2",
              attrs: {
                placeholder: "Label",
                label: "Label",
                "help-options": {
                  content: "Label displayed on order and in checkout.",
                  html: true,
                },
              },
              model: {
                value: _vm.tempItem.label,
                callback: function ($$v) {
                  _vm.$set(_vm.tempItem, "label", $$v)
                },
                expression: "tempItem.label",
              },
            }),
            _c("validated-input", {
              attrs: {
                label: "Type",
                placeholder: "Type",
                type: "select",
                options: _vm.types,
                "value-field": "type",
                "text-field": "label",
                disabled: !_vm.tempItem.enabled,
                "help-options": {
                  content: "Type of input displayed to users and customers.",
                  html: true,
                },
              },
              model: {
                value: _vm.tempItem.type,
                callback: function ($$v) {
                  _vm.$set(_vm.tempItem, "type", $$v)
                },
                expression: "tempItem.type",
              },
            }),
          ],
          1
        ),
        _c("div", [
          _c("label", [_vm._v("Image")]),
          _c(
            "div",
            [
              _c("UploadButton", {
                attrs: {
                  multiple: false,
                  hasImageType: false,
                  folder: _vm.uploadFolder,
                  resize: "200",
                },
                model: {
                  value: _vm.tempItemImage,
                  callback: function ($$v) {
                    _vm.tempItemImage = $$v
                  },
                  expression: "tempItemImage",
                },
              }),
            ],
            1
          ),
        ]),
        _vm.tempItem.type === "select"
          ? _c(
              "div",
              { staticClass: "mb-3" },
              [
                _c(
                  "b-tabs",
                  {
                    staticClass: "nav-tabs-underline mt-3",
                    attrs: { "content-class": "mt-3" },
                  },
                  [
                    _c("b-tab", { attrs: { title: "Options" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "label",
                            { attrs: { for: "tags-basic" + _vm.uniqueKey } },
                            [
                              _vm._v("\n              Options\n              "),
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.hover",
                                    value: {
                                      content:
                                        "Enter options to be diplayed in the select dropdown.",
                                      html: true,
                                    },
                                    expression:
                                      "{\n                  content: 'Enter options to be diplayed in the select dropdown.',\n                  html: true\n                }",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass:
                                  "fas fa-question-circle text-light ml-2",
                              }),
                            ]
                          ),
                          _c("b-form-tags", {
                            attrs: {
                              "input-id": "tags-basic" + _vm.uniqueKey,
                              placeholder: "Add new option",
                              "data-id": "mPower-referenceFieldInputOptions",
                            },
                            model: {
                              value: _vm.tempItem.options,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempItem, "options", $$v)
                              },
                              expression: "tempItem.options",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("b-tab", { attrs: { title: "Options Images" } }, [
                      _c("div", [
                        _c("label", [_vm._v("Options Image")]),
                        _c(
                          "div",
                          [
                            _c("UploadButton", {
                              attrs: {
                                multiple: true,
                                hasImageType: false,
                                folder: _vm.uploadFolder,
                                resize: "200",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "actions",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "mb-2" },
                                          [
                                            _c("label", [_vm._v("Option")]),
                                            _c("multiselect", {
                                              attrs: {
                                                multiple: false,
                                                options: _vm.tempItem.options,
                                              },
                                              model: {
                                                value: item.option,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "option", $$v)
                                                },
                                                expression: "item.option",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1483943338
                              ),
                              model: {
                                value: _vm.tempItem.optionsImages,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tempItem, "optionsImages", $$v)
                                },
                                expression: "tempItem.optionsImages",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {},
          [
            _c("validated-input", {
              attrs: {
                label: "Description",
                placeholder: "Description",
                type: "text-area",
                disabled: !_vm.tempItem.enabled,
              },
              model: {
                value: _vm.tempItem.description,
                callback: function ($$v) {
                  _vm.$set(_vm.tempItem, "description", $$v)
                },
                expression: "tempItem.description",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "mb-2",
            attrs: { "data-id": "mPower-referenceFieldInputEnabled" },
          },
          [
            _c(
              "b-form-checkbox",
              {
                model: {
                  value: _vm.tempItem.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.tempItem, "enabled", $$v)
                  },
                  expression: "tempItem.enabled",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.tempItem.target === "order"
                        ? "Show in checkout"
                        : "Show in store"
                    ) +
                    "\n        "
                ),
                _c("i", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.hover",
                      value: {
                        content: `If checked reference field will be displayed in the ${
                          _vm.tempItem.target === "order" ? "checkout" : "store"
                        }.`,
                      },
                      expression:
                        "{\n            content: `If checked reference field will be displayed in the ${tempItem.target === 'order' ? 'checkout' : 'store'}.`\n          }",
                      modifiers: { hover: true },
                    },
                  ],
                  staticClass: "fas fa-question-circle text-light ml-2",
                }),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "mb-2",
            attrs: { "data-id": "mPower-referenceFieldInputRequired" },
          },
          [
            _c(
              "b-form-checkbox",
              {
                model: {
                  value: _vm.tempItem.required,
                  callback: function ($$v) {
                    _vm.$set(_vm.tempItem, "required", $$v)
                  },
                  expression: "tempItem.required",
                },
              },
              [
                _vm._v("\n        Required\n        "),
                _c("i", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.hover",
                      value: {
                        content:
                          "If checked users will be required to enter this reference field when checking out.",
                      },
                      expression:
                        "{\n            content: 'If checked users will be required to enter this reference field when checking out.'\n          }",
                      modifiers: { hover: true },
                    },
                  ],
                  staticClass: "fas fa-question-circle text-light ml-2",
                }),
              ]
            ),
          ],
          1
        ),
        _vm.tempItem.required
          ? _c(
              "div",
              { staticClass: "mb-2" },
              [
                _c("label", [_vm._v("Require based on...")]),
                _c("validated-input", {
                  attrs: {
                    placeholder: "Select reference fields",
                    type: "select",
                    options: _vm.anotherFields,
                    "value-field": "_id",
                    "text-field": "label",
                  },
                  on: { change: _vm.clearRequiredBasedOnOptions },
                  model: {
                    value: _vm.tempItem.requiredBasedOn,
                    callback: function ($$v) {
                      _vm.$set(_vm.tempItem, "requiredBasedOn", $$v)
                    },
                    expression: "tempItem.requiredBasedOn",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.requiredBasedOnFieldType === "select"
          ? _c(
              "div",
              { staticClass: "mb-2" },
              [
                _c("label", [_vm._v("Require based on options...")]),
                _c("multiselect", {
                  attrs: {
                    multiple: true,
                    options: _vm.requiredBasedOnOptions,
                  },
                  model: {
                    value: _vm.tempItem.requiredBasedOnOptions,
                    callback: function ($$v) {
                      _vm.$set(_vm.tempItem, "requiredBasedOnOptions", $$v)
                    },
                    expression: "tempItem.requiredBasedOnOptions",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "mb-2" },
          [
            _c("label", [_vm._v("Visible based on...")]),
            _c("validated-input", {
              attrs: {
                placeholder: "Select reference fields",
                type: "select",
                options: _vm.anotherFields,
                "value-field": "_id",
                "text-field": "label",
              },
              on: { change: _vm.clearVisibleBasedOnOptions },
              model: {
                value: _vm.tempItem.visibleBasedOn,
                callback: function ($$v) {
                  _vm.$set(_vm.tempItem, "visibleBasedOn", $$v)
                },
                expression: "tempItem.visibleBasedOn",
              },
            }),
          ],
          1
        ),
        _vm.visibleBasedOnFieldType === "select"
          ? _c(
              "div",
              { staticClass: "mb-2" },
              [
                _c("label", [_vm._v("Visible based on options...")]),
                _c("multiselect", {
                  attrs: { multiple: true, options: _vm.visibleBasedOnOptions },
                  model: {
                    value: _vm.tempItem.visibleBasedOnOptions,
                    callback: function ($$v) {
                      _vm.$set(_vm.tempItem, "visibleBasedOnOptions", $$v)
                    },
                    expression: "tempItem.visibleBasedOnOptions",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.isOrderReferenceField
          ? _c("div", [
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.tempItem.requirePayment,
                        callback: function ($$v) {
                          _vm.$set(_vm.tempItem, "requirePayment", $$v)
                        },
                        expression: "tempItem.requirePayment",
                      },
                    },
                    [_vm._v(" Require Payment ")]
                  ),
                ],
                1
              ),
              _vm.tempItem.requirePayment
                ? _c(
                    "div",
                    { staticClass: "mb-2" },
                    [
                      _c("label", [
                        _vm._v("Require Payment based on options..."),
                      ]),
                      _c("multiselect", {
                        attrs: {
                          multiple: true,
                          options: _vm.tempItem.options,
                        },
                        model: {
                          value: _vm.tempItem.requirePaymentBasedOn,
                          callback: function ($$v) {
                            _vm.$set(_vm.tempItem, "requirePaymentBasedOn", $$v)
                          },
                          expression: "tempItem.requirePaymentBasedOn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.tempItem.dontRequireShippingAddress,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.tempItem,
                            "dontRequireShippingAddress",
                            $$v
                          )
                        },
                        expression: "tempItem.dontRequireShippingAddress",
                      },
                    },
                    [_vm._v(" Don’t Require Shipping Address ")]
                  ),
                ],
                1
              ),
              _vm.tempItem.dontRequireShippingAddress
                ? _c(
                    "div",
                    { staticClass: "mb-2" },
                    [
                      _c("label", [
                        _vm._v(
                          "Don’t Require Shipping Address based on options..."
                        ),
                      ]),
                      _c("multiselect", {
                        attrs: {
                          multiple: true,
                          options: _vm.tempItem.options,
                        },
                        model: {
                          value: _vm.tempItem.dontRequireShippingAddressBasedOn,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tempItem,
                              "dontRequireShippingAddressBasedOn",
                              $$v
                            )
                          },
                          expression:
                            "tempItem.dontRequireShippingAddressBasedOn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tempItem.dontRequireShippingAddress
                ? _c(
                    "div",
                    { staticClass: "mb-2" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value:
                              _vm.tempItem.calculateTaxUsingDistributorAddress,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.tempItem,
                                "calculateTaxUsingDistributorAddress",
                                $$v
                              )
                            },
                            expression:
                              "tempItem.calculateTaxUsingDistributorAddress",
                          },
                        },
                        [_vm._v("Calculate Tax using the distributor address ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.tempItem.dontRequireShippingAmount,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.tempItem,
                            "dontRequireShippingAmount",
                            $$v
                          )
                        },
                        expression: "tempItem.dontRequireShippingAmount",
                      },
                    },
                    [_vm._v(" Don’t require shipping amount ")]
                  ),
                ],
                1
              ),
              _vm.tempItem.dontRequireShippingAmount
                ? _c(
                    "div",
                    { staticClass: "mb-2" },
                    [
                      _c("label", [
                        _vm._v(
                          "Don’t require shipping amount based on options..."
                        ),
                      ]),
                      _c("multiselect", {
                        attrs: {
                          multiple: true,
                          options: _vm.tempItem.options,
                        },
                        model: {
                          value: _vm.tempItem.dontRequireShippingAmountBasedOn,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tempItem,
                              "dontRequireShippingAmountBasedOn",
                              $$v
                            )
                          },
                          expression:
                            "tempItem.dontRequireShippingAmountBasedOn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.tempItem.linkToCustomerRoles,
                        callback: function ($$v) {
                          _vm.$set(_vm.tempItem, "linkToCustomerRoles", $$v)
                        },
                        expression: "tempItem.linkToCustomerRoles",
                      },
                    },
                    [
                      _vm._v("\n          Link to customer roles\n          "),
                      _c("i", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover",
                            value: {
                              content:
                                "If checked, during checkout if a customer has multiple roles and they choose a reference field that matches the role name only send approval and confirmation emails to the managers of the role that has been matched.  This helps prevent all managers of a customer from being emailed and only the manager with the related role to be copied on emails.",
                            },
                            expression:
                              "{\n              content:\n                'If checked, during checkout if a customer has multiple roles and they choose a reference field that matches the role name only send approval and confirmation emails to the managers of the role that has been matched.  This helps prevent all managers of a customer from being emailed and only the manager with the related role to be copied on emails.'\n            }",
                            modifiers: { hover: true },
                          },
                        ],
                        staticClass: "fas fa-question-circle text-light ml-2",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "mt-4" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary mr-2",
              attrs: {
                disabled: _vm.disabled,
                type: "submit",
                "data-id": "mPower-referenceFieldSubmit",
              },
            },
            [_vm._v("Save")]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-link",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel", _vm.tempItem)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }